<template>
    <div class="container-fluid">
        <div v-if="noResults">
            <div class="text-muted">
                <i class="fa fa-spinner fa-spin mr-2"></i>Loading...
            </div>
        </div>
        <div v-else>
            <h4 class="mb-3">Dividends</h4>
            <div v-for="(market) in unique(dividends, 'marketId')" :key="market.marketId" class="mb-4">
                <h5 class="text-muted mb-2">{{ market.marketName }}</h5>
                <div class="table-responsive">
                    <table class="table table-dark table-striped table-bordered table-sm small">
                        <thead>
                            <tr>
                                <th scope="col">Security</th>
                                <th scope="col">Ex Date</th>
                                <th scope="col" class="d-none d-md-table-cell">Record Date</th>
                                <th scope="col" class="d-none d-md-table-cell">Payable Date</th>
                                <th scope="col" class="text-right">Franking</th>
                                <th scope="col" class="text-center">Sell?</th>
                                <th scope="col" class="text-right">Dividend</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dividend, index) in filteredMarkets(market.marketId)" :key="index">
                                <td>
                                    <span class="font-weight-bold">{{ dividend.code }}</span>
                                </td>
                                <td class="text-nowrap">{{ formatDate(dividend.exDate) }}</td>
                                <td class="text-nowrap d-none d-md-table-cell">{{ formatDate(dividend.recordDate) }}</td>
                                <td class="text-nowrap d-none d-md-table-cell">{{ formatDate(dividend.payableDate) }}</td>
                                <td class="text-right">
                                    <span v-if="dividend.frankingRate !== null" class="badge badge-secondary">{{ dividend.frankingRate }}%</span>
                                </td>
                                <td class="text-center">
                                    <i v-if="shouldShowSellWarning(dividend.maxTradeDate)" class="fa fa-times text-danger" title="Traded within last 45 days"></i>
                                </td>
                                <td class="text-right">{{ dividend.divAmount | currency('$') }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="font-weight-bold">
                                <td :colspan="4" class="text-right d-none d-md-table-cell">Total</td>
                                <td colspan="1" class="text-right d-md-none">Total</td>
                                <td class="d-none d-md-table-cell"></td>
                                <td></td>
                                <td class="text-right">
                                    {{ sum(filteredMarkets(market.marketId), 'divAmount') | currency('$') }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            portfolioguid: String
        },
        data: function () {
            return {
                securities: [],
                items: [],
                dividends: [],
                portfolioGuid: this.portfolioguid,
                security: this.securityprop,
                noResults: true
            }
        },
        async mounted() {
            this.getDividends();
        },
        methods: {
            applyColor(field) {
                if (field >= 0) return 'text-success';
                if (field < 0) return 'text-danger';

            },
            getData(obj) {
                console.log(obj);
            },
            getSecurities: function (security) {
                return this.items.find(a => a.security === security)
            },
            filteredMarkets(marketId) {
                return this.dividends.filter(item => item.marketId === marketId);
            },
            filteredItems(security) {
                return this.items.filter(item => item.security === security);
            },
            filteredDividends(security) {
                return this.dividends.filter(item => item.code === security);
            },
            shouldShowSellWarning(maxTradeDate) {
                if (!maxTradeDate) return false;
                var tradeDate = new Date(maxTradeDate);
                var daysAgo = (new Date() - tradeDate) / (1000 * 60 * 60 * 24);
                return daysAgo < 45;
            },
            editDividend: function (div) {
                //var self = this;

                var divEdit = { portfolioId: div.portfolioId, SecurityDividendId: div.securityDividendsId, isReceived: div.isReceived };

                console.log(divEdit);

                axios.post('/api/trades/editdividend', divEdit)
                    .then(function () {

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            async getDividends() {

                const { data } = await axios.get('/api/trades/GetDividendsByPortfolio', {
                    params: {
                        portfolioGuid: this.portfolioGuid
                    }
                });

                this.dividends = data;
                this.noResults = data.length === 0;
            }
        }
    }
</script>
